module.exports = __webpack_public_path__ + "img/base.7c56044d.png";